import type { MessageType } from 'magpie-types';
import { createError } from './create-error';

export const MessageSubscribeError = createError(
  'MessageSubscribeError',
  (messageType: MessageType) =>
    `Failed to subscribe to messages of type ${messageType}.`,
  {
    HANDSHAKE_FAILED: 'Connection unavailable. Handshake not finalized.',
    CONNECTION_UNAVAILABLE: "Connection wasn't opened",
  } as const
);
